export function filterThemeOrderSelectableMemberCards(records = []) {
  if (!Array.isArray(records)) return []
  return records.filter(item => Number(item.cardType) !== 2)
}
